import { ChatDrawerMessage } from 'ducks/chatDrawer'
import { Box } from 'opensolar-ui'
import React from 'react'
import { ChatMessageFeedbackButtons } from './ChatMessageFeedbackButtons'
import { ChatMessageFeedbackProvider } from './ChatMessageFeedbackProvider'
import { CopyMessageButton } from './CopyMessageButton'

interface MessageActionsWrapperProps {
  message: ChatDrawerMessage
  showFeedback?: boolean
}

export const MessageActionsWrapper: React.FC<MessageActionsWrapperProps> = ({ message, showFeedback = false }) => {
  if (showFeedback) {
    return (
      <ChatMessageFeedbackProvider message={message}>
        <Box display="flex" flexDirection="column" alignItems="flex-end" marginTop="8px" marginBottom="8px">
          <Box display="flex" alignItems="center" style={{ gap: '4px' }}>
            <CopyMessageButton message={message} />
            <ChatMessageFeedbackButtons renderButtons />
          </Box>
          <ChatMessageFeedbackButtons renderExpandableContent />
        </Box>
      </ChatMessageFeedbackProvider>
    )
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end" marginTop="8px" marginBottom="8px">
      <CopyMessageButton message={message} />
    </Box>
  )
}
